import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import * as _ from 'lodash';
import { filter, finalize, map, tap } from 'rxjs/operators';
import { SiteService } from '../services/site.service';
import { UserService } from '../services/user.service';
import { landingRoute } from '../utils/landing-route';

@Injectable({
  providedIn: 'root',
})
export class NotAuthenticatedGuard implements CanActivate {
  constructor(
    private siteService: SiteService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService
  ) {}

  canActivate() {
    this.siteService.addSubscriptionLog(
      this,
      'not-authenticated.guard.ts->canActivate->this.authenticationService.isAuthenticated'
    );

    return this.authenticationService.isAuthenticated.pipe(
      finalize(() =>
        this.siteService.setSubscriptionLogFinalised(
          'not-authenticated.guard.ts->canActivate->this.authenticationService.isAuthenticated'
        )
      ),
      // Skip until authenticated service checking is finish
      filter((authenticated) => authenticated !== null),
      map((authenticated) => {
        if (!authenticated) {
          return true;
        }
        const user = this.userService.userSourceValue;
        return this.router.parseUrl(landingRoute(user));
      })
    );
  }
}
